module.exports = __webpack_public_path__ + "img/Task Status Checked Preview.19bfae60.svg";